export const THEMES = {
  LIGHT: "light",
  DARK: "dark"
};
export const isDark = theme => theme.palette.mode === "dark";